import { enableFamilyInviteV2Flow } from "config";

import ChildConnectionSuccess from "./ChildConnectionSuccess";
import ChildConnectionSuccessV2 from "./ChildConnectionSuccessV2";

export default enableFamilyInviteV2Flow
  ? ChildConnectionSuccessV2
  : ChildConnectionSuccess;
